module.exports = __webpack_public_path__ + "img/AA1.9bac5d84.png";